import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: 30 },
  inputProviderPull: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 2fr 1fr',
    alignItems: 'center',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '0px',
      gap: '0px'
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  iconsSection: {
    paddingLeft: 34
  },
  twoIconsSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '34px'
  }
}))
export default useStyles
